import React, { useContext } from 'react'
import pages, { Page } from '../../../pages'
import { FormattedMessage } from 'react-intl'
import { ChevronType, Color, Direction } from '../../../utils/constants'
import { FormattedMessageWithClass, Link } from '../../../utils/helpers'
import HeaderContext from './HeaderContext'
import Chevron from '../../../components/Chevron'
import { twMerge } from 'tailwind-merge'
import HeaderLink from './HeaderLink'

interface HeaderLinksProps {
  isMobile?: boolean
  color: Color
  careerOpeningsCount: number
}

const HeaderLinks = ({
    isMobile = false,
    color,
    careerOpeningsCount,
}: HeaderLinksProps): JSX.Element => {
    const { headerColor } = useContext(HeaderContext)
    const renderPage = (
        { path, title, external = false }: Page,
        inDropdown: boolean,
        isMobile = false,
    ): JSX.Element => {
        return (
            <Link to={path} key={path} className='w-fit' external={external}>
                <div className='relative'>
                    <div className='flex items-center group'>
                        {isMobile ? (
                            <FormattedMessageWithClass id={title} className='text-2xl' />
                        ) : (
                            <FormattedMessage id={title}>
                                {(value) => (
                                    <span
                                        className={twMerge(
                                            'transition header-link',
                                            inDropdown && 'group-hover:text-purple',
                                        )}
                                    >
                                        {value}
                                    </span>
                                )}
                            </FormattedMessage>
                        )}
                        {inDropdown && (
                            <Chevron
                                direction={Direction.RIGHT}
                                className='transition flex-shrink-0 w-4 opacity-0 group-hover:opacity-100 fill-purple'
                                type={ChevronType.FULL}
                            />
                        )}
                    </div>
                    {/*
                    {title === 'page.careers' && careerOpeningsCount > 0 && (
                        <div
                            className={twMerge(
                                'absolute rounded-full p-1 text-[10px] -top-1/2 right-0 -mr-6 w-5 h-5 flex items-center justify-center font-semibold',
                                [Color.PURPLE, Color.BLACK].includes(headerColor)
                                    ? 'bg-white text-black'
                                    : 'bg-purple text-white',
                            )}
                        >
                            {careerOpeningsCount}
                        </div>
                    )}*/}
                </div>
            </Link>
        )
    }

    const availableLinks = pages
        .filter((page) => !!page.title)
        .reduce((groupedLinks, page) => {
            const key: string = (page.parent ?? page.title) as string
            const value = groupedLinks.get(key)
            return groupedLinks.set(key, value ? [...value, page] : [page])
        }, new Map<string, Page[]>())

    const renderLinks = () => {
        return Array.from(availableLinks.entries()).map(([key, value]) => {
            if (isMobile) {
                return value.map((page) => renderPage(page, false, isMobile))
            } else {
                return <HeaderLink key={key} id={key} value={value} color={color} renderPage={renderPage} />
            }
        })
    }

    return (
        <React.Fragment>
            {renderLinks()}
            {isMobile && (
                <Link to='/contact'>
                    <div className='relative'>
                        <div className='flex items-center group'>
                            <FormattedMessageWithClass id='page.contactUs' className='text-2xl' />
                        </div>
                    </div>
                </Link>
            )}
        </React.Fragment>
    )
}

export default HeaderLinks
